import React from 'react'
import AlumniComponent from '../components/AlumniComponent'
import CarouselComponent from '../components/CarouselComponent';
import image1 from '../Image/nss.png'
import NoticeBoard from '../sections/NoticesSection';
import Notice from '../resources/alumninotice.json'
import {Row,Col,Button} from 'react-bootstrap'
import TableComponent from '../components/TableComponent';
import ImageSlider from '../components/portfolioslider';
import ReadMoreComponent from '../components/ReadMoreComponent';
import nssdata from '../resources/nss.json'
import NssComponent from "../components/NssComponent"




const Alumni = () => {
    const data = "The NSS unit of Calcutta Girls&rsquo; College started operating in the late Nineties and has gone from strength to strength with every passing year. Regular activities throughout the year comprised of college safai programmes , poster competitions on environmental awareness, visits to adopted slum, free health camps, general health awareness programmes, programmes to observe World AIDS Day, programme to observe cancer awareness, programmes to observe World Environment Day, seminar on&nbsp; awareness of dengue and other water borne diseases and covid -19, organizing rallies on awareness of dengue and other water borne diseases, volunteers and teachers participated in&nbsp; rallies on road safety week, observing National Youth Day, observing Independence Day, observing The National Republic Day, organizing Saraswati Puja and so many programmes. The College NSS unit has also participated in Anti-drug programmes and other seminars on social issues conducted by the University of Calcutta. Volunteers have also bagged prizes for quiz and other programmes in similar events.<br /><br />The NSS unit of our college has the commiittee of Dr. Satya Upadhayaya( Principal, Chairperson,), Prof. Prem Kumar Ghosh( Programme Officer), Prof. Nupur Roy( Teacher Member), Prof. Bijoya Saha( Teacher Member), Prof. Sreyashi Chowdhury( Teacher Member), Prof. Suparna Bhattacharya( Teacher Member).<br /><br />In every year a special camp is held or 7days in our college in the month of March. The nature of the activities to be held at the camp was decided by the NSS committee in discussion with the volunteers on the daily basis. Free medical check-ups were organized where physiotherapists, general physicians, gynecologists, pediatricians attended to the health requirements of slum dwellers and students. Free medicines were distributed at the health camp. Film shows were organized for children. All participants of the slum were given prizes and goodies to enhance their interest and encourage their support.The college NSS unit was appreciated for its programmes in the field of social welfare.We had realise the principal ideal of Swamiji&rsquo;s philosophy &ldquo; Not me but you substantial measure.The students of our college had continuously made the NSS programmes a success through their selfless service and dedicated involvement. We hope to see our NSS unit flourish and new heights of excellence in the sphere of community service in future.</h1><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>."
    const temp = [
        {  name: 'Mrs.Prem Kumar Ghosh', designation: 'Convenor' },
        {  name: 'Mrs. Nupur Roy ', designation: 'Member' },
        {  name: 'Mrs.Bijoya Saha', designation: 'Member' },
        {  name: 'Mrs.Suparna Bhattacharya ', designation: 'Member' },
      ];

     
     
    const alumniImages=[image1];
  return (
    <>
    <div><CarouselComponent data={alumniImages}/></div>
    <div>
      <br></br>
    <h2>NATIONAL SOCIAL SERVICE</h2>
    <ReadMoreComponent data={data}/></div>

    <div className='container shadow p-3 mb-5 bg-white rounded'>
      <br></br>
        <div ><Button variant='primary' className='btn btn-primary btn-sm' style={{marginLeft: '70rem'}}>NSS Registration Form</Button></div><br></br>
        <Row  >
            <Col className='container-sm'>
            <h4>NSS Committee</h4>
            <TableComponent tabledata={temp} />
            </Col>
        </Row>
    </div>
    <br></br>
    <div><NssComponent data={nssdata}/></div>
    </>
  )
}

export default Alumni